function ContactUs() {
  return (
    <div className="contact-us" id="contact-us">
      <hr style={{ marginLeft: "5%", marginRight: "5%" }} />
      <div className="container" style={{ padding: "50px" }}>
        <div className="row justify-content-md-center">
          <div
            className="col-md-12"
            style={{ margin: "0px auto 50px auto", width: "100%" }}
          >
            <h2
              style={{
                textAlign: "center",
                fontFamily: "Barlow Semi Condensed",
                fontSize: "50px",
              }}
            >
              Contact
            </h2>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div
            className="col-md-6 justify-content-md-center text-center"
            style={{ marginBottom: "40px" }}
          >
            <h3>Management</h3>
            <p>Gregory Scott - MusicRISE Entertainment</p>
            <a href="mailto:gregory@musicrise.ca">gregory@musicrise.ca</a>
          </div>
          <div className="col-md-6 justify-content-md-center text-center">
            <h3>Publicist</h3>
            <p>Beverly Kreller - SPEAK Music</p>
            <a href="mailto:bev@speak-music.com">bev@speak-music.com</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
